import { VueExtension } from '../../utils/extensions/vue';
import Slider from './slider.jsx';
import './slider.scss';

VueExtension.WithInstall(Slider);

export default Slider;